import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ organizationId = '', ...params }) => {
  return await dponetAPI.get(`/backoffice/organizations/${organizationId}`, {
    params,
  })
}

const create = async ({ ...data }) => {
  return await dponetAPI.post(`/backoffice/organizations`, data)
}

const update = async ({ organizationId = '', ...params }) => {
  return await dponetAPI.put(
    `/backoffice/organizations/${organizationId}`,
    params,
  )
}

const changeStatus = async ({ organizationId = '' }) => {
  return await dponetAPI.put(
    `/backoffice/organizations/${organizationId}/change_status`,
  )
}

const changeDPO = async ({ organizationId = '', ...params }) => {
  return await dponetAPI.put(
    `/backoffice/organizations/${organizationId}/change_dpo`,
    params,
  )
}

const softDelete = async ({ organizationId = '' }) => {
  return await dponetAPI.put(
    `/backoffice/organizations/${organizationId}/soft_delete`,
  )
}

const organizations = {
  changeDPO,
  changeStatus,
  create,
  get,
  update,
  softDelete,
}

export default organizations
